<template>
    <div>
        <vx-card class="mb-0">
            <div class="container mx-auto px-4">
                <div class="mb-4 mt-5">
                    <div class="flex items-center justify-between mb-4 bg-gradient-to-r from-blue-600 to-indigo-600 p-4 rounded-lg shadow-lg">
                        <div>
                            <h2 class="text-white text-2xl font-bold">Reporte de Ventas por Periodo</h2>
                            <p class="text-blue-100 text-sm">Seleccione uno o varios periodos para generar el reporte</p>
                        </div>
                        <div class="flex gap-3">
                            <vs-button color="success" type="filled" @click="exportar" class="shadow-md">
                                <i class="fa-solid fa-file-excel"></i> Exportar
                            </vs-button>
                            <vs-button color="success" type="filled" icon="refresh" @click="recargarPedidos" class="shadow-md">
                                Recargar
                            </vs-button>
                            <vs-button color="danger" type="filled" icon="clear" @click="limpiarSeleccion" class="shadow-md">
                                Limpiar
                            </vs-button>
                        </div>
                    </div>
                    <v-select multiple :options="arrayPeriodos" label="periodoescolar" :reduce="p => p.idperiodoescolar"
                        v-model="periodoSelect" class="w-full multi-select-height shadow-sm" @input="f_get_pedidos_periodos" 
                        placeholder="Seleccione periodos..." />
                    
                    <!-- Buscador -->
                    <div v-if="pedidos.length > 0" class="mt-4 bg-white p-4 rounded-lg shadow-md border border-gray-200">
                        <div class="flex items-center gap-3">
                            <span class="text-gray-400 text-xl">🔍</span>
                            <input 
                                v-model="searchQuery" 
                                type="text" 
                                placeholder="Buscar por institución, pedido, asesor..." 
                                class="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            />
                            <span class="text-sm text-gray-600">{{ pedidosFiltrados.length }} de {{ pedidos.length }} registros</span>
                        </div>
                    </div>
                </div>

                <!-- Tabla de Reportes CORREGIDA -->
                <div class="mt-8 overflow-x-auto">
                    <table class="min-w-full bg-white shadow-xl rounded-lg overflow-hidden">
                        <thead>
                            <tr class="bg-gradient-to-r from-blue-700 via-indigo-700 to-purple-700 text-white">
                                <th class="py-4 px-6 text-left font-bold text-sm uppercase tracking-wider text-white">
                                    <div class="flex items-center gap-2">
                                        <span>🏢</span>
                                        <span>Institución</span>
                                    </div>
                                </th>
                                <th class="py-4 px-6 text-left font-bold text-sm uppercase tracking-wider text-white">
                                    <div class="flex items-center gap-2">
                                        <span>📋</span>
                                        <span>Convenio & Resumen</span>
                                    </div>
                                </th>
                                <th class="py-4 px-6 text-left font-bold text-sm uppercase tracking-wider text-white">
                                    <div class="flex items-center gap-2">
                                        <span>💰</span>
                                        <span>Detalle de Pagos</span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="pedidos.length === 0">
                                <td colspan="3" class="text-center py-4 text-gray-500">
                                    No hay pedidos para mostrar
                                </td>
                            </tr>
                            <tr v-for="pedido in pedidosFiltrados" :key="pedido.id_pedido" class="hover:bg-gradient-to-r hover:from-blue-50 hover:to-indigo-50 transition-all duration-200">
                                <td class="py-6 px-6 bg-gradient-to-br from-white to-gray-50">
                                    <div class="space-y-2">
                                        <div class="flex items-center gap-3 mb-3">
                                            <!-- <div class="bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full w-12 h-12 flex items-center justify-center font-bold text-lg shadow-lg" style="color: #ffffff !important;">
                                                <span style="color: #ffffff !important;">{{ pedido.id_pedido }}</span>
                                            </div> -->
                                            <div>
                                                <p class="font-bold text-gray-800 text-base">{{ pedido.nombreInstitucion }}</p>
                                                <p class="text-xs text-gray-500">Pedido: {{ pedido.pedido_institucion_id }} | Convenio: {{ pedido.pedidos_convenios_id }}</p>
                                            </div>
                                        </div>
                                        <div class="bg-white p-3 rounded-lg border border-gray-200 shadow-sm">
                                            <p class="text-sm text-gray-700 flex items-center gap-2">
                                                <span>👤</span>
                                                <span class="font-medium text-gray-800">{{ pedido.asesor_nombres }} {{ pedido.asesor_apellidos }}</span>
                                            </p>
                                            <p class="text-xs text-gray-600 mt-1">{{ pedido.contrato_generado }}</p>
                                            <div class="mt-2 flex gap-2">
                                                <span class="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-xs font-semibold">{{ pedido.tipo_venta_descr }}</span>
                                                <span class="bg-purple-100 text-purple-700 px-3 py-1 rounded-full text-xs font-semibold">{{ pedido.nombre_periodo }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td class="py-6 px-6 bg-gradient-to-br from-gray-50 to-blue-50">
                                    <div class="space-y-3">
                                        <!-- KPIs Grid -->
                                        <div class="grid grid-cols-2 gap-3">
                                            <div class="bg-white p-3 rounded-lg border-l-4 border-blue-500 shadow-sm">
                                                <p class="text-xs text-gray-600 uppercase font-semibold">Global</p>
                                                <p class="text-lg font-bold text-gray-900">{{ pedido.convenio_global }}</p>
                                            </div>
                                            <div class="bg-white p-3 rounded-lg border-l-4 border-emerald-500 shadow-sm">
                                                <p class="text-xs text-gray-600 uppercase font-semibold">Convenio Pagado</p>
                                                <p class="text-lg font-bold text-gray-900">{{ pedido.valor_convenio_pagado | filtrarDecimal2 }}</p>
                                            </div>
                                            <div class="bg-white p-3 rounded-lg border-l-4 border-amber-500 shadow-sm">
                                                <p class="text-xs text-gray-600 uppercase font-semibold">Convenio x Pagar</p>
                                                <p class="text-lg font-bold text-gray-900">{{ pedido.convenio_x_pagar | filtrarDecimal2 }}</p>
                                            </div>
                                            <div class="bg-white p-3 rounded-lg border-l-4 border-rose-500 shadow-sm">
                                                <p class="text-xs text-gray-600 uppercase font-semibold">Pagos Pendientes</p>
                                                <p class="text-lg font-bold text-gray-900">{{ pedido.pagosPendientes | filtrarDecimal2 }}</p>
                                            </div>
                                            <div class="bg-white p-3 rounded-lg border-l-4 border-teal-500 shadow-sm">
                                                <p class="text-xs text-gray-600 uppercase font-semibold">Pagos Pagados</p>
                                                <p class="text-lg font-bold text-gray-900">{{ pedido.pagosLiquidaciones | filtrarDecimal2 }}</p>
                                            </div>
                                            <div class="bg-white p-3 rounded-lg border-l-4 border-orange-500 shadow-sm">
                                                <p class="text-xs text-gray-600 uppercase font-semibold">Pagos x Pagar</p>
                                                <p class="text-lg font-bold text-gray-900">{{ pedido.pagos_x_pagar | filtrarDecimal2 }}</p>
                                            </div>
                                        </div>
                                        
                                        <!-- Info adicional -->
                                        <div class="bg-white p-3 rounded-lg border border-gray-200 text-xs shadow-sm">
                                            <p class="flex items-center gap-2">
                                                <span>⏰</span>
                                                <span class="text-gray-700">Tiempo: {{ pedido.convenio_anios }} años | Inicio: {{ pedido.inicio_convenio }}</span>
                                            </p>
                                            <p class="flex items-center gap-2 mt-1">
                                                <span>📊</span>
                                                <span class="text-gray-700">Estado: <span class="font-semibold text-gray-800">{{ pedido.estado_convenio }}</span></span>
                                            </p>
                                            <p v-if="pedido.observacion" class="mt-1 text-gray-600 italic">{{ pedido.observacion }}</p>
                                        </div>
                                    </div>
                                    
                                    <!-- Resumen de totales destacado -->
                                    <div class="mt-4 bg-white p-5 rounded-xl shadow-2xl border-2 border-indigo-500">
                                        <div class="mb-4 pb-4 border-b-2 border-gray-300">
                                            <p class="text-xs uppercase tracking-wider mb-1 flex items-center gap-2 text-gray-600 font-semibold">
                                                <span>✅</span>
                                                <span>Total Pagado</span>
                                            </p>
                                            <p class="font-black text-3xl text-green-600">{{ (pedido.valor_convenio_pagado + pedido.pagosLiquidaciones) | filtrarDecimal2 }}</p>
                                        </div>
                                        <div>
                                            <p class="text-xs uppercase tracking-wider mb-1 flex items-center gap-2 text-gray-600 font-semibold">
                                                <span>⚠️</span>
                                                <span>Total x Pagar</span>
                                            </p>
                                            <p class="font-black text-3xl text-orange-600">{{ (pedido.convenio_x_pagar + pedido.pagos_x_pagar) | filtrarDecimal2 }}</p>
                                        </div>
                                    </div>

                                </td>
                                <td class="py-6 px-6 bg-white">
                                    <div v-if="pedido.cantidad_pagos_total > 0">
                                        <div class="flex items-center justify-between mb-4">
                                            <p class="font-bold text-gray-800 text-lg">Total: {{ pedido.cantidad_pagos_total }} pagos</p>
                                        </div>
                                        
                                        <!-- Badges de resumen -->
                                        <div class="grid grid-cols-2 gap-3 mb-5">
                                            <div class="bg-gradient-to-br from-emerald-50 to-emerald-100 p-3 rounded-lg border-l-4 border-emerald-500 shadow-md">
                                                <p class="text-xs text-gray-800 font-semibold flex items-center gap-1">
                                                    <span>✅</span>
                                                    <span class="text-gray-800">Cerrados Pago</span>
                                                </p>
                                                <p class="text-gray-900 font-black text-xl">{{ pedido.pagos_cerrados_pago | filtrarDecimal2 }}</p>
                                            </div>
                                            <div class="bg-gradient-to-br from-amber-50 to-amber-100 p-3 rounded-lg border-l-4 border-amber-500 shadow-md">
                                                <p class="text-xs text-gray-800 font-semibold flex items-center gap-1">
                                                    <span>⏳</span>
                                                    <span class="text-gray-800">Abiertos Pago</span>
                                                </p>
                                                <p class="text-gray-900 font-black text-xl">{{ pedido.pagos_abiertos_pago | filtrarDecimal2 }}</p>
                                            </div>
                                            <div class="bg-gradient-to-br from-teal-50 to-teal-100 p-3 rounded-lg border-l-4 border-teal-500 shadow-md">
                                                <p class="text-xs text-gray-800 font-semibold flex items-center gap-1">
                                                    <span>✅</span>
                                                    <span class="text-gray-800">Cerrados Convenio</span>
                                                </p>
                                                <p class="text-gray-900 font-black text-xl">{{ pedido.pagos_cerrados_convenio | filtrarDecimal2 }}</p>
                                            </div>
                                            <div class="bg-gradient-to-br from-orange-50 to-orange-100 p-3 rounded-lg border-l-4 border-orange-500 shadow-md">
                                                <p class="text-xs text-gray-800 font-semibold flex items-center gap-1">
                                                    <span>⏳</span>
                                                    <span class="text-gray-800">Abiertos Convenio</span>
                                                </p>
                                                <p class="text-gray-900 font-black text-xl">{{ pedido.pagos_abiertos_convenio | filtrarDecimal2 }}</p>
                                            </div>
                                        </div>

                                        <!-- Tabla unificada de pagos premium -->
                                        <div class="rounded-xl overflow-hidden shadow-lg tabla-pagos-interna">
                                            <table class="min-w-full bg-white">
                                                <thead>
                                                    <tr class="bg-gray-200">
                                                        <th class="py-3 px-3 text-left text-xs font-bold uppercase text-gray-900">ID</th>
                                                        <th class="py-3 px-3 text-left text-xs font-bold uppercase text-gray-900">Beneficiario</th>
                                                        <th class="py-3 px-3 text-left text-xs font-bold uppercase text-gray-900">Subtotal</th>
                                                        <th class="py-3 px-3 text-left text-xs font-bold uppercase text-gray-900">IVA</th>
                                                        <th class="py-3 px-3 text-left text-xs font-bold uppercase text-gray-900">Retención</th>
                                                        <th class="py-3 px-3 text-left text-xs font-bold uppercase text-gray-900">Total</th>
                                                        <th class="py-3 px-3 text-left text-xs font-bold uppercase text-gray-900">Tipo</th>
                                                        <th class="py-3 px-3 text-left text-xs font-bold uppercase text-gray-900">Forma Pago</th>
                                                        <th class="py-3 px-3 text-left text-xs font-bold uppercase text-gray-900">Estado</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="pago in pedido.todos_los_pagos" :key="pago.id_pedido_pago_detalle" class="hover:bg-blue-50 transition-all duration-150">
                                                        <td class="py-3 px-3 text-xs font-semibold" style="color: #111827 !important;">{{ pago.id_pedido_pago_detalle }}</td>
                                                        <td class="py-3 px-3 text-xs" style="color: #111827 !important;">
                                                            <div v-if="pago.razon_social">
                                                                <p class="font-semibold">{{ pago.razon_social }}</p>
                                                                <p class="text-gray-600 text-xs">{{ pago.documento_dni || 'Sin documento' }}</p>
                                                            </div>
                                                            <div v-else>
                                                                <p>{{ pago.nombre_completo || 'N/A' }}</p>
                                                                <p class="text-gray-600 text-xs">{{ pago.documento_dni || 'Sin documento' }}</p>
                                                            </div>
                                                        </td>
                                                        <td class="py-3 px-3 text-xs" style="color: #111827 !important;">{{ pago.subtotal | filtrarDecimal2 }}</td>
                                                        <td class="py-3 px-3 text-xs" style="color: #111827 !important;">{{ pago.iva_valor | filtrarDecimal2 }}</td>
                                                        <td class="py-3 px-3 text-xs" style="color: #111827 !important;">{{ pago.retencion | filtrarDecimal2 }}</td>
                                                        <td class="py-3 px-3 text-xs font-bold" style="color: #111827 !important;">{{ pago.total_calculado | filtrarDecimal2 }}</td>
                                                        <td class="py-3 px-3 text-xs">
                                                            <span class="px-2 py-1 rounded-full font-semibold" :class="{
                                                                'bg-blue-100 text-blue-800': pago.tipo_pago_id === 1,
                                                                'bg-purple-100 text-purple-800': pago.tipo_pago_id === 2,
                                                                'bg-indigo-100 text-indigo-800': pago.tipo_pago_id === 7,
                                                                'bg-teal-100 text-teal-800': pago.tipo_categoria === 'Convenio'
                                                            }">
                                                                {{ pago.tipo_pago_texto }}
                                                            </span>
                                                        </td>
                                                        <td class="py-3 px-3 text-xs" style="color: #111827 !important;">{{ pago.forma_pago_nombre || 'N/A' }}</td>
                                                        <td class="py-3 px-3 text-xs">
                                                            <span class="px-2 py-1 rounded-full font-semibold" :class="pago.estado === 1 ? 'bg-emerald-100 text-emerald-800' : 'bg-amber-100 text-amber-800'">
                                                                {{ pago.estado_texto }}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div v-else class="text-center py-12">
                                        <p class="text-gray-400 italic text-lg">📭 Sin pagos registrados</p>
                                    </div>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </vx-card>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import Generalmix from '@/mixins/Generalmix';
import Codigosmix from "@/mixins/Codigosmix";
export default {
    mixins: [Generalmix,Codigosmix],
    components: {
        vSelect,
    },
    data() {
        return {
            arrayPeriodos: [],
            periodoSelect: null,
            totalVenta: 0,
            totalVentaDescuento: 0,
            pedidos: [],
            searchQuery: '',
        }
    },

    computed: {
        pedidosFiltrados() {
            if (!this.searchQuery) {
                return this.pedidos;
            }
            const query = this.searchQuery.toLowerCase();
            return this.pedidos.filter(pedido => {
                return (
                    (pedido.nombreInstitucion && pedido.nombreInstitucion.toLowerCase().includes(query)) ||
                    (pedido.id_pedido && pedido.id_pedido.toString().includes(query)) ||
                    (pedido.pedido_institucion_id && pedido.pedido_institucion_id.toString().includes(query)) ||
                    (pedido.asesor_nombres && pedido.asesor_nombres.toLowerCase().includes(query)) ||
                    (pedido.asesor_apellidos && pedido.asesor_apellidos.toLowerCase().includes(query)) ||
                    (pedido.contrato_generado && pedido.contrato_generado.toLowerCase().includes(query)) ||
                    (pedido.tipo_venta_descr && pedido.tipo_venta_descr.toLowerCase().includes(query))
                );
            });
        }
    },

    mounted() {
        this.obtenerPeriodos()
    },

    methods: {
        obtenerPeriodos() {
            let me = this;
            this.$http.get(this.$server_url + 'periodo_nombre')
                .then(res => {
                    console.log('Periodos obtenidos:', res.data);
                    me.arrayPeriodos = res.data;
                })
        },
        f_get_pedidos_periodos() {
            console.log('IDs seleccionados:', this.periodoSelect);
            if (!this.periodoSelect || this.periodoSelect.length === 0) {
                console.warn('No hay periodos seleccionados');
                return;
            }

            this.$vs.loading();

            this.$http.post(this.$server_url + 'obtenerPedidosPorPeriodo', {
                periodos: this.periodoSelect // 👈 ya es array de IDs
            })
                .then(res => {
                    console.log('Pedidos:', res.data.data);
                    this.pedidos = res.data.data;
                })
                .catch(err => {
                    console.error('Error:', err);
                })
                .finally(() => {
                    this.$vs.loading.close();
                });
        },
        recargarPedidos() {
            if (!this.periodoSelect || this.periodoSelect.length === 0) {
                this.$vs.notify({
                    title: 'Advertencia',
                    text: 'Debe seleccionar al menos un periodo',
                    color: 'warning',
                    position: 'top-right'
                });
                return;
            }
            this.f_get_pedidos_periodos();
        },
        limpiarSeleccion() {
            this.periodoSelect = null;
            this.pedidos = [];
            this.$vs.notify({
                title: 'Limpiado',
                text: 'Selección de periodos limpiada',
                color: 'success',
                position: 'top-right'
            });
        },
        exportar() {
            let me = this;
            
            if (!me.pedidos || me.pedidos.length === 0) {
                me.$vs.notify({
                    title: 'Advertencia',
                    text: 'No hay datos para exportar',
                    color: 'warning',
                    position: 'top-right'
                });
                return;
            }

            // Preparar datos para exportar cada detalle de pago como una fila
            let dataExport = [];
            
            me.pedidos.forEach((pedido) => {
                // Si tiene pagos, exportar cada pago como una fila
                if (pedido.todos_los_pagos && pedido.todos_los_pagos.length > 0) {
                    pedido.todos_los_pagos.forEach((pago) => {
                        dataExport.push({
                            contrato: pedido.contrato_generado || '',
                            institucion: pedido.nombreInstitucion || '',
                            asesor: `${pedido.asesor_nombres || ''} ${pedido.asesor_apellidos || ''}`.trim(),
                            tipo_venta: pedido.tipo_venta_descr || '',
                            periodo: pedido.nombre_periodo || '',
                            // Datos del pago
                            id_pago: pago.id_pedido_pago_detalle || '',
                            beneficiario: pago.razon_social || pago.nombre_completo || 'N/A',
                            documento_dni: pago.documento_dni || '',
                            subtotal: (parseFloat(pago.subtotal) || 0).toFixed(2) * 1,
                            iva: (parseFloat(pago.iva_valor) || 0).toFixed(2) * 1,
                            retencion: (parseFloat(pago.retencion) || 0).toFixed(2) * 1,
                            total: (parseFloat(pago.total_calculado) || 0).toFixed(2) * 1,
                            tipo_pago: pago.tipo_pago_texto || '',
                            forma_pago: pago.forma_pago_nombre || 'N/A',
                            estado: pago.estado_texto || '',
                        });
                    });
                }
                // Si no tiene pagos, no exportar nada para este pedido
            });

            let nameFile = 'reporte_detalle_pagos_por_periodo';
            let headers = [
                'Contrato',
                'Institución',
                'Asesor',
                'Tipo Venta',
                'Periodo',
                'ID Pago',
                'Beneficiario',
                'Documento',
                'Subtotal',
                'IVA',
                'Retención',
                'Total',
                'Tipo Pago',
                'Forma Pago',
                'Estado',
            ];
            
            let fieldKeys = [
                'contrato',
                'institucion',
                'asesor',
                'tipo_venta',
                'periodo',
                'id_pago',
                'beneficiario',
                'documento_dni',
                'subtotal',
                'iva',
                'retencion',
                'total',
                'tipo_pago',
                'forma_pago',
                'estado',
            ];

            if (typeof me.m_exportTodo === 'function') {
                me.m_exportTodo(headers, fieldKeys, dataExport, nameFile);
            } else if (me.$parent && typeof me.$parent.m_exportTodo === 'function') {
                me.$parent.m_exportTodo(headers, fieldKeys, dataExport, nameFile);
            } else {
                me.$vs.notify({
                    title: 'Error',
                    text: 'Función de exportación no disponible',
                    color: 'danger',
                    position: 'top-right'
                });
            }
        }
    }
}
</script>

<style scoped>
/* Forzar colores oscuros SOLO en cards con fondo claro */
.bg-white .kpi-label,
.bg-white .kpi-value,
.bg-gradient-to-br.from-emerald-50 p,
.bg-gradient-to-br.from-amber-50 p,
.bg-gradient-to-br.from-teal-50 p,
.bg-gradient-to-br.from-orange-50 p {
    color: #1f2937 !important;
}

/* Borders visibles en filas de tabla principal */
tbody > tr {
    border-bottom: 5px solid #9ca3af !important;
}

/* Borders en tabla interna de pagos */
.tabla-pagos-interna {
    border: 3px solid #6b7280 !important;
}

.tabla-pagos-interna tbody tr {
    border-bottom: 2px solid #d1d5db !important;
}

.tabla-pagos-interna tbody tr:last-child {
    border-bottom: none !important;
}

/* ── KPI Grid ── */
.kpi-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 10px;
    margin-top: 16px;
}

.kpi-card {
    border-radius: 8px;
    padding: 14px 16px;
    border-left: 4px solid transparent;
    background: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.kpi-label {
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    color: #4b5563 !important;
    margin-bottom: 5px;
}

.kpi-value {
    font-size: 17px;
    font-weight: 700;
    color: #111827 !important;
}

.kpi-blue {
    border-color: #93c5fd;
    background: #eff6ff;
}

.kpi-orange {
    border-color: #fdba74;
    background: #fff7ed;
}

.kpi-green {
    border-color: #86efac;
    background: #f0fdf4;
}

.kpi-purple {
    border-color: #c4b5fd;
    background: #f5f3ff;
}

.kpi-teal {
    border-color: #5eead4;
    background: #f0fdfa;
}

.kpi-indigo {
    border-color: #a5b4fc;
    background: #eef2ff;
}

.kpi-cyan {
    border-color: #67e8f9;
    background: #ecfeff;
}

.kpi-yellow {
    border-color: #fde68a;
    background: #fffbeb;
}

.kpi-red {
    border-color: #fca5a5;
    background: #fef2f2;
}

.kpi-gray {
    border-color: #cbd5e1;
    background: #f8fafc;
}
</style>
